import { messaging } from "JS/Helpers/UserMessaging";
import { useDisclosurePrefetch } from "JS/React/Hooks/DisclosurePrefetch";

import { QueueItems } from "./QueueItems";

// Disclosures are prefetched for the whole catalogue, so this row is shown
// rather than queued: it carries no controls and cannot be reordered or
// removed, because it never enters the download queue at all.
export const DisclosureQueueItem = () => {
    const { show, total, completed, percentage } = useDisclosurePrefetch();

    if (!show) return null;

    return (
        <QueueItems
            contentType="audio"
            contentTitle={messaging.disclosure.queueTitle}
            isShowProgress={true}
            isDownloading={true}
            downloadPercentage={percentage}
            downloadingSpeed={messaging.disclosure.queueProgress(
                completed,
                total,
            )}
        />
    );
};
